import { useQuery } from '@tanstack/react-query';

import { fetchCameraSetup } from '@data';

const getCameraSetupKey = (activityId: number) => ['activity', activityId, 'cameraSetup'];

export const useCameraSetup = (activityId: number) => {
    return useQuery({
        queryKey: getCameraSetupKey(activityId),
        queryFn: () => fetchCameraSetup(activityId),
        enabled: activityId >= 0,
    });
};
